import { Box, Divider } from '@material-ui/core';
import { HomeIcon } from '@setvi/shared/components/sicons';
import { HomeButton as HomeBtn } from './style';

interface HomeButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const HomeButton = ({ onClick, disabled = false }: HomeButtonProps) => (
  <Box display="flex" alignItems="center">
    <HomeBtn onClick={onClick} disabled={disabled}>
      <HomeIcon fill="#fff" viewBox="-2 -2 28 28" />
    </HomeBtn>
    <Divider orientation="vertical" flexItem />
  </Box>
);
